import { gql } from '@apollo/client';

export const ACCEPT_CREDIT = gql`
  mutation AcceptCredit($creditId: String!) {
    acceptCredit(creditId: $creditId) {
      id
    }
  }
`;
